import { MSG_SIN_PERMISO, NOTAS_MAX } from './constants';

// Validacion basica en cliente; el backend normaliza y valida de nuevo.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const normalizarEmail = (valor) => (valor ?? '').toString().trim().toLowerCase();

export const esEmailValido = (valor) => EMAIL_RE.test(normalizarEmail(valor));

export const normalizarNotas = (valor) => (valor ?? '').toString().trim() || null;

export const validarFormulario = ({ email, notas }) => {
  const errores = {};
  if (!esEmailValido(email)) errores.email = 'Introduce un email válido.';
  if ((notas ?? '').trim().length > NOTAS_MAX) {
    errores.notas = `Las notas no pueden superar los ${NOTAS_MAX} caracteres.`;
  }
  return errores;
};

// Solo los campos que cambian respecto a la fila: el PATCH no debe tocar el resto
// (y un email reenviado fuerza una nueva consulta a Google Workspace).
export const calcularCambios = (usuario, { email, activo, notas }) => {
  const cambios = {};
  if (!usuario) return cambios;
  const emailNorm = normalizarEmail(email);
  if (emailNorm !== usuario.email) cambios.email = emailNorm;
  if (activo !== usuario.activo) cambios.activo = activo;
  const notasNorm = normalizarNotas(notas);
  if (notasNorm !== (usuario.notas ?? null)) cambios.notas = notasNorm;
  return cambios;
};

export const mensajeError = (error, generico) => {
  const status = error?.response?.status;
  if (status === 403) return MSG_SIN_PERMISO;
  // Un 400 es de la validación (Zod) del backend, con mensaje técnico en inglés.
  if (status === 400) return 'Revisa los datos: el email o las notas no son válidos.';
  return error?.response?.data?.error || generico;
};
